import { Typography, Tabs } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const { Title } = Typography;

const PromotionalMessages = ({ promotionalMessages, setPromotionalMessages }) => {
  const handleInputChange = (platform, value) => {
    setPromotionalMessages((prev) => ({
      ...prev,
      [platform]: value,
    }));
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      ["link"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "color",
    "background",
    "link",
  ];

  const tabItems = [
    {
      key: "discord",
      label: (
        <span className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm">
          <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
          </svg>
          <span className="hidden sm:inline">Discord</span>
        </span>
      ),
      children: (
        <div className="space-y-2">
          <Typography.Text className="text-xs sm:text-sm text-gray-600">
            Add a custom message that appears with your daily schedule posts on Discord.
          </Typography.Text>
          <ReactQuill
            theme="snow"
            value={promotionalMessages.discord}
            onChange={(value) => handleInputChange("discord", value)}
            modules={modules}
            formats={formats}
            placeholder="Enter Discord custom message"
            className="bg-white rounded-lg"
            style={{ height: "200px", marginBottom: "50px" }}
          />
        </div>
      ),
    },
    {
      key: "telegram",
      label: (
        <span className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm">
          <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19c-.14.75-.42 1-.68 1.03c-.58.05-1.02-.38-1.58-.75c-.88-.58-1.38-.94-2.23-1.5c-.99-.65-.35-1.01.22-1.59c.15-.15 2.71-2.48 2.76-2.69a.2.2 0 0 0-.05-.18c-.06-.05-.14-.03-.21-.02c-.09.02-1.49.95-4.22 2.79c-.4.27-.76.41-1.08.4c-.36-.01-1.04-.2-1.55-.37c-.63-.2-1.12-.31-1.08-.66c.02-.18.27-.36.74-.55c2.92-1.27 4.86-2.11 5.83-2.51c2.78-1.16 3.35-1.36 3.73-1.36c.08 0 .27.02.39.12c.1.08.13.19.14.27c-.01.06.01.24 0 .38z"/>
          </svg>
          <span className="hidden sm:inline">Telegram</span>
        </span>
      ),
      children: (
        <div className="space-y-2">
          <Typography.Text className="text-xs sm:text-sm text-gray-600">
            Add a custom message that appears with your daily schedule posts on Telegram
          </Typography.Text>
          <ReactQuill
            theme="snow"
            value={promotionalMessages.telegram}
            onChange={(value) => handleInputChange("telegram", value)}
            modules={modules}
            formats={formats}
            placeholder="Enter Telegram custom message"
            className="bg-white rounded-lg"
            style={{ height: "200px", marginBottom: "50px" }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="mt-0">
      <Title level={5} className="text-left mb-4 sm:mb-6">Custom Messages</Title>
      <Tabs
        defaultActiveKey="discord"
        items={tabItems}
        className="promotional-tabs"
        tabBarStyle={{ marginBottom: "16px" }}
      />
      <style jsx>{`
        .promotional-tabs .ant-tabs-tab {
          padding: 8px 12px;
          min-width: auto;
        }
        
        @media (min-width: 640px) {
          .promotional-tabs .ant-tabs-tab {
            padding: 12px 20px;
          }
        }
        
        .promotional-tabs .ant-tabs-tab-active {
          background: #f0f2f5;
          border-radius: 8px 8px 0 0;
        }
        
        .promotional-tabs .ant-tabs-nav {
          margin-bottom: 0;
        }
        
        .ql-container {
          font-family: inherit;
        }
        
        .ql-editor {
          min-height: 200px;
          font-size: 14px;
        }
        
        .ql-editor.ql-blank::before {
          font-style: normal;
          color: #bfbfbf;
        }
      `}</style>
    </div>
  );
};

export default PromotionalMessages;